import { render, staticRenderFns } from "./SellTicket.vue?vue&type=template&id=708457d7&scoped=true&"
import script from "./SellTicket.vue?vue&type=script&lang=js&"
export * from "./SellTicket.vue?vue&type=script&lang=js&"
import style0 from "./SellTicket.vue?vue&type=style&index=0&id=708457d7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708457d7",
  null
  
)

export default component.exports